import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
/* MODULES */
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {LoadingModule} from 'ngx-loading';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {ToastrModule} from 'ngx-toastr';
import {TreeviewModule} from 'ngx-treeview';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {UiSwitchModule} from 'ngx-ui-switch';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
//import {TabsModule} from 'ngx-bootstrap/tabs';
import {LightboxModule} from 'ngx-lightbox';
/* SERVICES */
import {SecuritymenuService} from '../services/securitymenu.service';
import {UserService} from '../services/user.service';
import {RoleService} from '../services/role.service';
import {BaseService} from '../base.service';
import {SliderService} from '../services/slider.service';
/* GUARDS */
import {AuthGuard} from '../guards/auth.guard';
/* ROUTING */
import {routing_dashboard} from './dashboard.routing';
/* OTROS */
import {Env} from '../env';
import {AuthInterceptor} from '../interceptor/authInterceptor';
/* COMPONENTS */
import {HeaderComponent} from './layout/header/header.component';
import {NavComponent} from './layout/nav/nav.component';
import {FooterComponent} from './layout/footer/footer.component';
import {DashboardComponent} from './dashboard.component';
import {Error404Component} from './error-404/error-404.component';
import {ShowErrorsComponent} from './show-errors/show-errors.component';
import {SystemOptionsComponent} from './system-options/system-options.component';
import {RoleComponent} from './role/role.component';
import {RoleInfoComponent} from './role/role-info.component';
import {CreateRoleComponent} from './role/create-role.component';
import {PermissionComponent} from './permission/permission.component';
import {UserComponent} from './user/user.component';
import {UserInfoComponent} from './user/user-info.component';
import {CreateUserComponent} from './user/create-user.component';
import {IndexComponent} from './index/index.component';
import {UploadComponent} from './shared/upload/upload.component';
import {ParamComponent} from './param/param.component';
import {FilterUserComponent} from './filter-user/filter-user.component';
import {MenuService} from '../services/menu.service';
import { MenuComponent } from './menu/menu.component';
import {MenuInfoComponent} from './menu/menu-info.component';
import { SliderComponent } from './slider/slider.component';
import { SliderListComponent } from './slider/slider-list.component';
import {CreateSliderComponent} from './slider/create-slider.component';
import { CreateBankComponent } from './bank/create-bank.component';
import { BankListComponent } from './bank/bank-list.component';
import { BankDetailComponent } from './bank/bank-detail.component';
import { BankService } from '../services/bank.service';
import { ParamService } from '../services/param.service';
import { ContractComponent } from './contract/contract.component';
import { ContractListComponent } from './contract/contract-list.component';
import { EvaluationListComponent } from './evaluation/evaluation-list.component';
import { EvaluationService } from '../services/evaluation.service';

import { EvaluationDetailComponent } from './evaluation/evaluation-detail.component';
import { PropertyListComponent } from './property/property-list.component';
import { PropertyComponent } from './property/property.component';
import { TAB_COMPONENTS } from './tabset/tabset.component';
import { ContractsService } from '../services/contracts.service';
import { PropertyService } from '../services/property.service';
import { DivisionService } from '../services/division.service';
import { PaymentService } from '../services/payment.service';
import { DivisionListComponent } from './division/division-list.component';
import { DivisionComponent } from './division/division.component';
import { TenantListComponent } from './tenant/tenant-list.component';
import { TenantService } from '../services/tenant.service';
import { TenantComponent } from './tenant/tenant.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
@NgModule({
  declarations: [
    HeaderComponent,
    NavComponent,
    FooterComponent,
    DashboardComponent,
    Error404Component,
    ShowErrorsComponent,
    SystemOptionsComponent,
    RoleComponent,
    RoleInfoComponent,
    CreateRoleComponent,
    PermissionComponent,
    FilterUserComponent,
    UserComponent,
    UserInfoComponent,
    CreateUserComponent,
    IndexComponent,
    UploadComponent,
    ParamComponent,
    MenuComponent,
    MenuInfoComponent,
    SliderComponent,
    SliderListComponent,
    ContractComponent,
    ContractListComponent,
    EvaluationListComponent,
    EvaluationDetailComponent,  
    PropertyListComponent,
    PropertyComponent,
    DivisionListComponent,
    DivisionComponent,
    TenantListComponent,
    TenantComponent,
  CreateSliderComponent,
  CreateBankComponent,
  BankListComponent,
  BankDetailComponent,
  TAB_COMPONENTS,
  SpinnerComponent,
    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    routing_dashboard,
    HttpClientModule,
    AngularFontAwesomeModule,
    NoopAnimationsModule,
    LoadingModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    PaginationModule.forRoot(),
    TreeviewModule.forRoot(),
    BsDatepickerModule.forRoot(),
    UiSwitchModule,
    TypeaheadModule.forRoot(),
    //TabsModule.forRoot(),
    LightboxModule,
    ReactiveFormsModule,
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthGuard,
    SecuritymenuService,
    UserService,
    RoleService,
    Env,
    BaseService,
    BankService,
    ParamService,
    [DatePipe],
    MenuService,
    SliderService,
    ContractsService,
    PropertyService,
    EvaluationService,
    DivisionService,
    PropertyService,
    PaymentService,
    TenantService,

  ],
  entryComponents: [
    ShowErrorsComponent
  ],
  bootstrap: [DashboardComponent]
})
export class DashboardModule { }




// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/dashboard.module.ts